export default {
  modalTitle: "Need more time?",
  modalIntro: "Your application will shortly timeout due to inactivity.",
  modalCountdown: " seconds",
  modalClose: "Do you need more time to continue your application?",
  modalButton: "Continue application"
};
